import formatFloatForDisplay from 'services/numbers/formatFloatForDisplay';
import { M2 } from 'services/enums/units';

/*
 * Per diem (päiväraha) of the other expenses: the row costs a per diem for each worker day of
 * the installation, its work days for each installer (e.g. 5 days of 2 installers make 10).
 * The rows are priced for one unit of the position, so its quantity is the worker days
 * divided by the quantity of the position, e.g. 10 worker days for 200 m² makes 0,05 per m²
 * and 54 € × 0,05 × 200 m² = 540 €, the per diems of the 10 worker days.
 */

export const DAILY_ALLOWANCE_TEXT = 'PÄIVÄRAHA / m2';
export const DAILY_ALLOWANCE_UNIT = M2;
export const DAILY_ALLOWANCE_PRICE = '54';
// Per diems have no social security costs
export const DAILY_ALLOWANCE_PERCENTAGE = '0';

// The quantity keeps decimals enough for a small share of a day for a unit
const QUANTITY_DECIMALS = 6;

/** The quantity of a per diem row for one unit of the position, empty without work days */
export const getDailyAllowanceQuantity = (
  workDays: number,
  positionQuantity: number
): string =>
  workDays > 0 && positionQuantity > 0
    ? formatFloatForDisplay(workDays / positionQuantity, QUANTITY_DECIMALS)
    : '';
